export default __webpack_public_path__ + "static/media/first.4beab8b2.mp4";